import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { esimAPI } from "../../services/api";
import i18n from "../../i18n";

export const purchaseESIM = createAsyncThunk(
  "esim/purchase",
  async (packageData, { rejectWithValue }) => {
    try {
      const response = await esimAPI.purchase(packageData);
      return response.data;
    } catch (error) {
      return rejectWithValue(i18n.t("errors.purchaseESIMFailed"));
    }
  }
);

const esimSlice = createSlice({
  name: "esim",
  initialState: {
    currentPurchase: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(purchaseESIM.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(purchaseESIM.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPurchase = action.payload;
      })
      .addCase(purchaseESIM.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default esimSlice.reducer;
